
import Nav from '@/components/Nav.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: { Footer, Nav },
};
